<template>
    <AisRefinementList :attribute="name" show-more :limit="4" :sort-by="sortBy">
        <template
            v-slot="{ items, isShowingMore, canToggleShowMore, refine, createURL, toggleShowMore }"
        >
            <div class="filter-checkboxes" v-show="items.length">
                <div class="title" v-if="title">{{ title }}</div>
                <ul class="checkboxes">
                    <li class="checkbox" v-for="item in items" :key="item.value">
                        <label>
                            <input
                                type="checkbox"
                                @click="refine(item.value)"
                                v-model="item.isRefined"
                            />
                            <span></span>
                            <a
                                href="javascript:"
                                @click.prevent="refine(item.value)"
                                rel="nofollow"
                            >
                                <span>{{ formatDate(item.value) }}</span>
                                <small>({{ item.count.toLocaleString() }})</small>
                            </a>
                        </label>
                    </li>
                </ul>
                <a
                    href="javascript:"
                    class="more"
                    v-if="props.showMore && canToggleShowMore"
                    @click="toggleShowMore"
                >
                    {{ !isShowingMore ? '+ Vis flere' : '- Vis mindre' }}
                </a>
            </div>
        </template>
    </AisRefinementList>
</template>
<script setup lang="ts">
    const props = defineProps({
        name: {
            required: true,
            type: String,
        },
        title: {
            required: true,
            type: String,
        },
        sortBy: {
            required: false,
            type: Array,
        },
        showMore: {
            required: false,
            type: Boolean,
        },
    })

    const formatDate = (dateStr) => {
        const date = new Date(dateStr)
        const dateYear = date.toLocaleDateString('nb-NO', {
            year: 'numeric',
        })
        const currentYear = new Date().toLocaleDateString('nb-NO', {
            year: 'numeric',
        })

        if (dateYear === currentYear) {
            return new Date(date).toLocaleDateString('nb-NO', {
                month: 'long',
            })
        } else {
            return new Date(date).toLocaleDateString('nb-NO', {
                month: 'long',
                year: 'numeric',
            })
        }
    }
</script>
